export const ENV = {
  PROD: 'prod',
  UAT: 'uat',
  QA: 'qa',
  DEV: 'dev',
}

export const HOST = window.location.hostname.toLowerCase().split('.')[0]

export const SERVER_VERSION = {
  V2: 'V2',
  V3: 'V3',
}

export const TOKEN_TYPE = {
  JWT: 'JWT',
}

export const SERVER_VERSION_MAP = {
  unite: SERVER_VERSION.V2,
  unite3: SERVER_VERSION.V3,
}

export const URL2ENV = {
  localhost: ENV.DEV,
  app: ENV.PROD,
  uat: ENV.UAT,
  qa: ENV.QA,
  dev: ENV.DEV,
}
